"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _get = function get(_x2, _x3, _x4) {
  var _again = true;

  _function: while (_again) {
    var object = _x2,
        property = _x3,
        receiver = _x4;
    _again = false;
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        _x2 = parent;
        _x3 = property;
        _x4 = receiver;
        _again = true;
        desc = parent = undefined;
        continue _function;
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  }
};

exports["default"] = context;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function context(name) {
  var type = arguments.length <= 1 || arguments[1] === undefined ? _propTypes2["default"].any.isRequired : arguments[1];
  return function contextDecorator(Component) {
    var ContextDecorator = function (_React$Component) {
      _inherits(ContextDecorator, _React$Component);

      function ContextDecorator() {
        _classCallCheck(this, ContextDecorator);

        _get(Object.getPrototypeOf(ContextDecorator.prototype), "constructor", this).apply(this, arguments);
      }

      _createClass(ContextDecorator, [{
        key: "render",
        value: function render() {
          return _react2["default"].createElement(Component, _extends({}, this.context, this.props));
        }
      }], [{
        key: "contextTypes",
        value: _defineProperty({}, name, type),
        enumerable: true
      }, {
        key: "displayName",
        value: "ContextDecorator",
        enumerable: true
      }]);

      return ContextDecorator;
    }(_react2["default"].Component);

    return ContextDecorator;
  };
}

module.exports = exports["default"];